import React from "react";

import { SelectList } from "@common/selectList";
import { AddMemberIcon } from "../addMemberIcon";
import { ResourceAllocationMenu } from "@common/resourceAllocationMenu";
import { Props } from "./types";
import styles from "./styles.scss";
import {
  useAddEveryoneToResourceGroup,
  useAddResourceToResourceGroup,
  useRemoveResourceFromResourceGroup,
} from "@planzone/view-models";

function ResourceSelect({ resources, group }: Props) {
  const { addResourceToResourceGroup } = useAddResourceToResourceGroup(group, {
    uuid: "",
  });
  const { removeResourceFromResourceGroup } =
    useRemoveResourceFromResourceGroup(group, { uuid: "" });
  const { addEveryoneToResourceGroup, isRequestPending } =
    useAddEveryoneToResourceGroup(group);

  return (
    <SelectList listClassName={styles.list} multiple>
      {() => ({
        input: <AddMemberIcon className={styles.icon} />,
        list: (
          <ResourceAllocationMenu
            allocatedResources={resources}
            select={(selected) => {
              selected.forEach((resource) => {
                addResourceToResourceGroup({ group, resource });
              });
            }}
            unSelect={(unselected) => {
              unselected.forEach((resource) => {
                removeResourceFromResourceGroup({ group, resource });
              });
            }}
            everyone={{
              select: () => addEveryoneToResourceGroup({ group }),
              isPending: isRequestPending,
            }}
            openedViews={["resources"]}
          />
        ),
      })}
    </SelectList>
  );
}

export { ResourceSelect };
